// extracted by mini-css-extract-plugin
export default {"headerBar":"GH-z","pointsSection":"HH-z","goToDashboard":"IH-z"};